import React from "react";
import { AuthConsumer } from "./AuthProvider";

const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback();
            return <></>;
        }}
    </AuthConsumer>
);

export default SilentRenew;